import { Theme } from '@24i/nxg-sdk-photon';
import { ErrorMessageStyles } from '../types';

const getErrorMessageStyles = (theme: Theme): ErrorMessageStyles => ({
    container: { flex: 1, justifyContent: 'center', alignItems: 'center' },
    messageText: { color: theme.color.textPrimary },
});

export default getErrorMessageStyles;
